/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown>, currency: NonNullable<unknown> }} Admin_Discount_Code_Form_Discount_AmountInputs */

const en_admin_discount_code_form_discount_amount = /** @type {(inputs: Admin_Discount_Code_Form_Discount_AmountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.currency} off`)
};

const nl_admin_discount_code_form_discount_amount = /** @type {(inputs: Admin_Discount_Code_Form_Discount_AmountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.currency} korting`)
};

/** @type {(inputs: Admin_Discount_Code_Form_Discount_AmountInputs) => LocalizedString} */
const de_admin_discount_code_form_discount_amount = en_admin_discount_code_form_discount_amount;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_AmountInputs) => LocalizedString} */
const es_admin_discount_code_form_discount_amount = en_admin_discount_code_form_discount_amount;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_AmountInputs) => LocalizedString} */
const fr_admin_discount_code_form_discount_amount = en_admin_discount_code_form_discount_amount;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_AmountInputs) => LocalizedString} */
const it_admin_discount_code_form_discount_amount = en_admin_discount_code_form_discount_amount;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_AmountInputs) => LocalizedString} */
const pt_br2_admin_discount_code_form_discount_amount = en_admin_discount_code_form_discount_amount;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_AmountInputs) => LocalizedString} */
const pl_admin_discount_code_form_discount_amount = en_admin_discount_code_form_discount_amount;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_AmountInputs) => LocalizedString} */
const hu_admin_discount_code_form_discount_amount = en_admin_discount_code_form_discount_amount;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_AmountInputs) => LocalizedString} */
const ro_admin_discount_code_form_discount_amount = en_admin_discount_code_form_discount_amount;

/**
* | output |
* | --- |
* | "{value} {currency} off" |
*
* @param {Admin_Discount_Code_Form_Discount_AmountInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discount_code_form_discount_amount = /** @type {((inputs: Admin_Discount_Code_Form_Discount_AmountInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discount_Code_Form_Discount_AmountInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discount_code_form_discount_amount(inputs)
	if (locale === "de") return de_admin_discount_code_form_discount_amount(inputs)
	if (locale === "es") return es_admin_discount_code_form_discount_amount(inputs)
	if (locale === "fr") return fr_admin_discount_code_form_discount_amount(inputs)
	if (locale === "nl") return nl_admin_discount_code_form_discount_amount(inputs)
	if (locale === "it") return it_admin_discount_code_form_discount_amount(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discount_code_form_discount_amount(inputs)
	if (locale === "pl") return pl_admin_discount_code_form_discount_amount(inputs)
	if (locale === "hu") return hu_admin_discount_code_form_discount_amount(inputs)
	return ro_admin_discount_code_form_discount_amount(inputs)
});
export { admin_discount_code_form_discount_amount as "admin.discount_code_form.discount_amount" }